import TeachersList from './TeachersList';

export default TeachersList;
